import React, { useState, useEffect } from "react";

import Regions from "./regions";
import { getRegionPreparedData } from "./utils";

const RegionsTree = ({ companyObj, form }) => {
	const { getFieldValue, setFieldsValue } = form;
	const [selectedHouses, setSelectedHouses] = useState([]);
	const [preparedData, setPreparedData] = useState({});

	useEffect(() => {
		const selectedHouses = getFieldValue('addresses').reduce((acc, val, index) => {
			if (val) {
				acc.push(index);
			}

			return acc;
		}, []);
		setSelectedHouses(selectedHouses);
	}, []);

	useEffect(() => {
		const preparedData = getRegionPreparedData(
			companyObj,
			selectedHouses,
			setFieldsValue,
			setSelectedHouses
		);
		setPreparedData(preparedData);
	}, [selectedHouses]);

	return (
		<>
			{`УК ${preparedData.company}`}
			{preparedData.regions && <Regions regions={preparedData.regions} />}
		</>
	);
};
export default RegionsTree;
